import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { LICENSE_STATUS_EVENT } from "@/lib/api";

const TITLES: Record<string, string> = {
  LICENSE_EXPIRED: "License Expired",
  LICENSE_INACTIVE: "Account Inactive",
  LICENSE_INVALID: "License Invalid",
};

export default function LicenseBanner() {
  const [status, setStatus] = useState<{ code: string; message: string } | null>(null);

  useEffect(() => {
    const handler = (e: Event) => {
      const { code, message } = (e as CustomEvent<{ code: string; message: string }>).detail;
      setStatus({ code, message });
    };
    window.addEventListener(LICENSE_STATUS_EVENT, handler);
    return () => window.removeEventListener(LICENSE_STATUS_EVENT, handler);
  }, []);

  if (!status) return null;

  return (
    <Alert variant="destructive" className="rounded-none border-x-0 border-t-0">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>{TITLES[status.code] || "License Issue"}</AlertTitle>
      <AlertDescription>{status.message}</AlertDescription>
    </Alert>
  );
}
